module.exports = __webpack_public_path__ + "media/images/sp/brands/common/brand_menu_location_plans-995efcb34d04537c967ba4990d1049c3.jpg";